"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var dist_1 = require("@opengsn/common/dist");

var GAS_PRICE_PERCENT = 20;
var MAX_RELAY_NONCE_GAP = 3;
var DEFAULT_RELAY_TIMEOUT_GRACE_SEC = 1800;
var DEFAULT_LOOKUP_WINDOW_BLOCKS = 60000;
exports.defaultLoggerConfiguration = {
  logLevel: 'info'
};
exports.defaultGsnConfig = {
  preferredRelays: [],
  relayLookupWindowBlocks: DEFAULT_LOOKUP_WINDOW_BLOCKS,
  relayRegistrationLookupBlocks: Number.MAX_SAFE_INTEGER,
  pastEventsQueryMaxPageSize: Number.MAX_SAFE_INTEGER,
  gasPriceFactorPercent: GAS_PRICE_PERCENT,
  gasPriceOracleUrl: '',
  gasPriceOraclePath: '',
  minGasPrice: 0,
  maxRelayNonceGap: MAX_RELAY_NONCE_GAP,
  sliceSize: 3,
  relayTimeoutGrace: DEFAULT_RELAY_TIMEOUT_GRACE_SEC,
  methodSuffix: '_v4',
  requiredVersionRange: dist_1.gsnRequiredVersion,
  jsonStringifyRequest: true,
  auditorsCount: 1,
  clientId: '1'
};